import { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import reaLogo from "@/assets/rea-logo.png";
import { AdministrationModal } from "./AdministrationModal";
import { LoginModal, UserMenu } from "./LoginModal";
import { useAuth } from "@/hooks/useAuth";

export const Header = () => {
  const [isAdminModalOpen, setIsAdminModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  const isEmployeeDashboard = location.pathname === '/empleados';
  const isAdminDashboard = location.pathname === '/admin';
  const { user, signOut } = useAuth();

  const handleScrollToSection = (section: string, e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-b">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center space-x-8">
          <Link to="/" className="flex-shrink-0">
            <img src={reaLogo} alt="REA Managers" className="h-16 w-auto cursor-pointer" />
          </Link>
          {!isEmployeeDashboard && !isAdminDashboard && (
            <nav className="hidden md:flex items-center space-x-6">
              {isHome ? (
                <a 
                  href="#inicio"
                  onClick={(e) => handleScrollToSection('inicio', e)}
                  className="text-foreground hover:text-primary transition-colors text-lg font-semibold"
                  data-nav="inicio"
                >
                  Inicio
                </a>
              ) : (
                <Link 
                  to="/"
                  className="text-foreground hover:text-primary transition-colors text-lg font-semibold"
                  data-nav="inicio"
                >
                  Inicio
                </Link>
              )}
              
              {isHome ? (
                <a 
                  href="#proyectos"
                  onClick={(e) => handleScrollToSection('proyectos', e)}
                  className="text-foreground hover:text-primary transition-colors text-lg font-semibold"
                  data-nav="proyectos"
                >
                  Proyectos
                </a>
              ) : (
                <Link 
                  to="/"
                  className="text-foreground hover:text-primary transition-colors text-lg font-semibold"
                  data-nav="proyectos"
                >
                  Proyectos
                </Link>
              )}
              
              {isHome ? (
                <a 
                  href="#nosotros"
                  onClick={(e) => handleScrollToSection('nosotros', e)}
                  className="text-foreground hover:text-primary transition-colors text-lg font-semibold"
                  data-nav="nosotros"
                >
                  Nosotros
                </a>
              ) : (
                <Link 
                  to="/"
                  className="text-foreground hover:text-primary transition-colors text-lg font-semibold"
                  data-nav="nosotros"
                >
                  Nosotros
                </Link>
              )}
              
              <button 
                onClick={() => setIsAdminModalOpen(true)}
                className="text-foreground hover:text-primary transition-colors text-lg font-semibold"
                data-nav="administracion"
              >
                Administración
              </button>
              
              {isHome ? (
                <a 
                  href="#contacto"
                  onClick={(e) => handleScrollToSection('contacto', e)}
                  className="text-foreground hover:text-primary transition-colors text-lg font-semibold"
                  data-nav="contacto"
                >
                  Contacto
                </a>
              ) : (
                <Link 
                  to="/"
                  className="text-foreground hover:text-primary transition-colors text-lg font-semibold"
                  data-nav="contacto"
                >
                  Contacto
                </Link>
              )}

              <Link 
                to="/blog"
                className="text-foreground hover:text-primary transition-colors text-lg font-semibold"
                data-nav="blog"
              >
                Blog
              </Link>

              <Link 
                to="/reservas"
                className="text-foreground hover:text-primary transition-colors text-lg font-semibold"
                data-nav="reservas"
              >
                Reserva Ahora
              </Link>
            </nav>
          )}
        </div>
        
        <div className="flex items-center gap-4">
          {user ? (
            <UserMenu 
              userEmail={user.email || ''} 
              onLogout={signOut}
              showDashboardLink={true}
            />
          ) : (
            <button
              onClick={() => setIsLoginModalOpen(true)}
              className="text-foreground hover:text-primary transition-colors text-lg font-semibold"
            >
              Login
            </button>
          )}
        </div>
      </div>
      
      <AdministrationModal 
        isOpen={isAdminModalOpen} 
        onClose={() => setIsAdminModalOpen(false)} 
      />
      
      <LoginModal
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
      />
    </header>
  );
};
